module.exports = __webpack_public_path__ + "static/media/cert_rd.0be7c841.jpg";